import React, { createContext, useContext, useRef } from "react";

const DirectionsRendererContext = createContext(null);

export const DirectionsRendererProvider = ({ children }) => {
  const directionRendererRef = useRef(null);

  console.log("DirectionsRendererProvider rendered");
  console.log("Current DirectionsRenderer:", directionRendererRef.current);

  return (
    <DirectionsRendererContext.Provider value={directionRendererRef}>
      {children}
    </DirectionsRendererContext.Provider>
  );
};

export const useDirectionsRendererContext = () => {
  return useContext(DirectionsRendererContext);
};
